import React, { ReactNode } from 'react'

type CardContextValue = {
  cardId: string
  setCardId: (cardId: string) => void
}

export const CardIdContext = React.createContext<CardContextValue>({
  cardId: '',
  setCardId: () => {},
})

export const useCardId = () => React.useContext(CardIdContext)
